export const DEFAULT_SIZE = 'xl';

export const DEFAULT_THEME = 'blue';

export const DEFAULT_THICKNESS = 5;
